module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/steps/rc-step04-e7d3e70897da06e1024e92e05d25d94a.png";